import React from 'react';
import { Box, Stack, Card, Skeleton, Divider, Avatar } from '@mui/material';

// ----------------------------------------------------------------------

export function ChatThreadSkeleton({ count = 3 }) {
  return (
    <Box>
      {[...Array(count)].map((_, i) => (
        <Card
          key={i}
          sx={{
            p: 2,
            mb: 2.5,
            borderRadius: 2,
            boxShadow: 0,
            border: '1px solid',
            borderColor: 'divider',
          }}
        >
          {/* Main Message Header */}
          <Stack direction="row" spacing={2} alignItems="center">
            <Skeleton variant="circular" width={40} height={40} />
            <Box flex={1}>
              <Skeleton variant="text" width="40%" height={20} />
              <Skeleton variant="text" width="30%" height={16} />
            </Box>
          </Stack>

          {/* Main Message Body */}
          <Box sx={{ mt: 2, ml: 6 }}>
            <Skeleton variant="text" width="80%" height={18} sx={{ mb: 1 }} />
            <Skeleton variant="text" width="65%" height={18} />
          </Box>

          {/* Nested Replies */}
          <Box sx={{ mt: 2, ml: 8, pl: 2, borderLeft: '2px solid', borderColor: 'divider' }}>
            {[...Array(2)].map((it, idx) => (
              <Box key={idx} sx={{ mb: 2 }}>
                <Stack direction="row" spacing={1.5} alignItems="center">
                  <Skeleton variant="circular" width={32} height={32} />
                  <Box flex={1}>
                    <Skeleton variant="text" width="35%" height={18} />
                  </Box>
                </Stack>

                <Box sx={{ mt: 1.5, ml: 5 }}>
                  <Skeleton variant="text" width="80%" height={16} sx={{ mb: 0.5 }} />
                  <Skeleton variant="text" width="60%" height={16} />
                </Box>

                {/* One reply with image preview */}
                {idx === 0 && (
                  <Box
                    sx={{
                      mt: 2,
                      ml: 5,
                      borderRadius: 2,
                      overflow: 'hidden',
                      width: 260,
                      height: 150,
                    }}
                  >
                    <Skeleton variant="rectangular" width="100%" height="100%" />
                  </Box>
                )}
              </Box>
            ))}
          </Box>

          {/* Bottom divider */}
          {i < count - 1 && <Divider sx={{ mt: 2 }} />}
        </Card>
      ))}
    </Box>
  );
}
